module.exports = __webpack_public_path__ + "img/infografico.85aab05f.png";